import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';
import { TableLayoutFormlyFieldGroup } from '../../../../model/dyn-form/form-visualizer/formly-group.model';

@Component({
    selector: 'app-input-label-wrapper',
    templateUrl: './input-label-wrapper.html',
    styleUrl: './input-label-wrapper.scss',
    standalone: true,
    imports: [MatDividerModule, CommonModule, MatTooltipModule]
})
export class InputLabelWrapper extends FieldWrapper {

    isInTable(): boolean {
        return this.field.parent?.parent?.parent instanceof TableLayoutFormlyFieldGroup || false
    }
    
}
